import { useCallback, useEffect, useState } from 'react'
import { useBlocker, useLocation, useNavigate } from 'react-router-dom'

export function useCallbackPrompt(when: boolean) {
	const navigate = useNavigate()
	const location = useLocation()
	const [showPrompt, setShowPrompt] = useState<boolean>(false)
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const [lastLocation, setLastLocation] = useState<any>(null)
	const [confirmedNavigation, setConfirmedNavigation] = useState(false)

	const cancelNavigation = useCallback(() => {
		setShowPrompt(false)
		setLastLocation(null)
	}, [])
	const confirmNavigation = useCallback(() => {
		setShowPrompt(false)
		setConfirmedNavigation(true)
	}, [])

	useEffect(() => {
		if (confirmedNavigation && lastLocation) {
			navigate(lastLocation.pathname)
			setConfirmedNavigation(false)
		}
	}, [confirmedNavigation, lastLocation, navigate])

	useBlocker(
		when
			? tx => {
					if (
						!confirmedNavigation &&
						tx.nextLocation.pathname !== location.pathname
					) {
						setShowPrompt(true)
						setLastLocation(tx.nextLocation)
						return false
					}
					return true
				}
			: false,
	)

	return { showPrompt, setShowPrompt, confirmNavigation, cancelNavigation }
}
